<script lang="ts">
  // libs
  import { pluralize } from "@shared/svelte/Modules/pluralize";

  // components
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  // services
  import {
    getContainerCountString,
    getCartContainerCount,
  } from "@retailer/services/order_quantities_service";

  // stores
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

  // types
  import type { CartType } from "@shared/types/Cart";

  // props
  export let cart: CartType;

  $: blockedOrders = cart.orders?.filter(order => order.distributor?.ordering_disabled);
  $: blockedOrderTotal = blockedOrders?.reduce((total, order) => total + order.total, 0) || 0;
  $: blockedOrderItemCount =
    blockedOrders?.reduce((total, order) => total + order.products.length, 0) || 0;
  $: cartTotal = cart.total - blockedOrderTotal;
  $: totalAvailableItems = cart.total_items - blockedOrderItemCount;

  $: hasOnlyRequestedItems = cart.orders.every(order =>
    order.products.every(product => product.requested_item),
  );
</script>

<div
  class:fizz-stack-16={$LayoutStore.isDesktop}
  class:fizz-inset-square-16={$LayoutStore.isMobile}
>
  <div>
    <div class="fizz-flex-row fizz-space-between fizz-stack-2">
      <div class="fizz-tooltip-container">
        <button class="fizz-tooltip-trigger fizz-flex-row-8" aria-describedby="tooltip-pricing">
          <h4 class="fizz-heading-4" style="color: black;">
            Est. total ({pluralize("item", totalAvailableItems, true)})
          </h4>
          <div id="tooltip-target" tabIndex={0}>
            <Icon type="Info" color="black" extraClassNames="fizz-icon-12" />
          </div>
        </button>
        <div
          id="tooltip-pricing"
          data-testid="tooltip-pricing"
          class="fizz-tooltip fizz-tooltip-top"
          role="tooltip"
          style="--min-width: 260px; --max-width: 300px"
        >
          The price you see includes frontline prices and discounts provided to Provi by your
          distributor. Your invoice from your sales rep will reflect your final pricing.
        </div>
      </div>
      {#if cartTotal == 0 && !hasOnlyRequestedItems}
        <h4 class="fizz-heading-4 fizz-text-bold">Price not available</h4>
      {:else}
        <h4 class="fizz-heading-4"><FormatMoney input={cartTotal} formatType="5" /></h4>
      {/if}
    </div>
    {#if $LayoutStore.isDesktop}
      <p>{getContainerCountString(getCartContainerCount(cart))}</p>
    {/if}
  </div>
</div>
